import { useCallback, useEffect, useState } from 'react';
import { getFlatfileTree } from '../api/flatfile';
import { getDatabaseConnectionTree } from '../api/dbConnection';
import { getWebApiConnectionTree } from '../api/webApi';
interface ITree {
  workspaceId: string;
  workspaceName: string;
  contentType: 'dbConnection' | 'flatfile';
  contents: { id: string; name: string; createdBy: null | string };
  subworkspaces: ITree[];
}
export const useTree = (type: 'ff' | 'db' | 'wa') => {
  const [data, setData] = useState<ITree[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response =
        type === 'ff'
          ? await getFlatfileTree()
          : type === 'wa'
            ? await getWebApiConnectionTree()
            : await getDatabaseConnectionTree();

      if (!response.isError) {
        setData(response.data);
      } else {
        throw new Error('Error while fetching the data');
      }
    } catch (e: any) {
      setError({
        message: e.message ?? 'Error while fetching the data',
        code: e.code || 500,
        isError: true,
      });
    } finally {
      setLoading(false);
    }
  }, [type]);
  useEffect(() => {
    (async function () {
      await fetchData();
    })();
  }, [fetchData, type]);

  return { result: data, loading, error, refetch: fetchData };
};
